import { LogLevel } from '@azure/msal-browser';
import msalConfigFetched from './azure.config.json';

export const msalConfig = {
  auth: {
    clientId: msalConfigFetched.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${msalConfigFetched.TENANT_ID}`,
    clientSecret: msalConfigFetched.CLIENT_SECRET,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'user.read']
};

export const silentRequest = {
  scopes: ['openid', 'profile', 'email', 'user.read'],
  loginHint: 'example@domain.net'
};
